import React, { useState, useEffect } from "react";
import { getData } from "../../../serverRequest";
import LoadingSpinner from "../../../components/Loadder";
//import moment from 'moment';
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// components
import TimesheetListTable from "../../../components/Tables/TimesheetListTable";

export default function TimesheetList() {
  //const [open, setOpen] = React.useState(true);
  const [timesheets, setTimesheets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  /* const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const formatDate = (dateString) => {
      return moment(dateString).format('DD/MM/YYYY');
    }; */

   const filterTimesheetData = (timesheets_data) => {
     let totalTimesheets = [];
     if (timesheets_data) {
       for (let i = 0; i < timesheets_data.length; i++) {
         totalTimesheets.push(timesheets_data[i]);
       }
     }
  
     setTimesheets(totalTimesheets);
    return { total: totalTimesheets };
  };

  useEffect(() => {
    async function fetchData() {
      let resData = await getData(
        "/api/employee/timesheet_entry/?employee_id=" + 
          localStorage.getItem("employeeId")
      );
      let timesheets_data = resData["data"]["timesheet_entry"];
      console.log(timesheets_data);
      setTimesheets(timesheets_data ? timesheets_data : []); // Always set as array
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <>
      <main>
        <div className="relative block py-24 lg:pt-0 px-4">
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-blueGray-700 text-xl font-bold">Timesheet</h6>
              <div className="w-full lg:w-3/12 px-4">
                <div className="relative w- mb-3">
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    isClearable
                    placeholderText="Select Date Range"
                    className="w-full lg:w-3/12 mb-3 px-3 py-2 border rounded"
                  />
                </div>
              </div>
              <Link to="/admin/timesheetForm">
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  Add
                </button>
              </Link>
            </div>
          </div>
          {loading ? (
            <LoadingSpinner></LoadingSpinner>
          ) : (
            <>
              <div
                className={
                  "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                  ("light" === "light"
                    ? "bg-white"
                    : "bg-lightBlue-900 text-white")
                }
              >
                <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                  {/* Projects table */}
                  <TimesheetListTable
                    totalTimesheets={timesheets}
                  ></TimesheetListTable>
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </>
  );
}
